import { useState } from "react";
import { ButtonBase, IconButton, Stack, Typography } from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";

const CluppDropdown = ({
  title,
  subtitle,
  startIcon = null,
  endIcon = null,
  description = null,
  onClick = null,
  descriptionFunc = null,
  notBox = false,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false);
  function toggleVisibility() {
    setIsOpen((prev) => !prev);
  }
  const isClickable = description || onClick;
  const BaseComponent = isClickable ? ButtonBase : Stack;
  return (
    <BaseComponent
      {...rest}
      sx={{
        display: "flex",
        alignItems: "",
        flexDirection: description || descriptionFunc ? "column" : "row",
        justifyContent: "flex-start",
        background: "white",
        borderRadius: "10px",
        border: notBox ? "" : "1px solid #8A8A8A",
        marginBottom: "5px",
        marginTop: notBox ? "20px" : "",
        width: "100%",
      }}
    >
      <Stack
        onClick={description || descriptionFunc ? toggleVisibility : onClick}
        sx={{
          width: "100%",
          p: notBox ? "" : 2,
          boxSizing: "border-box",
        }}
        direction="row"
        alignItems="center"
        spacing={1}
      >
        {startIcon}
        <Stack sx={{ flex: "1", alignItems: "flex-start", textAlign: "left" }}>
          <Typography
            sx={{
              fontSize: ["0.85rem", "1rem"],
              fontWeight: 700,
              color: "#000",
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: ["0.85rem", "1rem"],
              textAlign: "left",
              color: "#8A8A8A",
            }}
          >
            {subtitle}
          </Typography>
        </Stack>
        {endIcon ? (
          endIcon
        ) : description || descriptionFunc ? (
          <IconButton>
            <KeyboardArrowDown
              sx={{
                transform: isOpen ? "rotate(180deg)" : "",
                transition: "transform ease 500ms ",
              }}
            />
          </IconButton>
        ) : null}
      </Stack>
      {(description || descriptionFunc) && (
        <Stack
          sx={{
            textAlign: "left",
            width: "100%",
            borderTop: "1px solid #8A8A8A",
            p: isOpen ? 2 : "",
            boxSizing: "border-box",
            overflow: "hidden",
            height: isOpen ? "" : "0px",
            display: isOpen ? "" : "none",
            transition: "all ease 500ms ",
            whiteSpace: "pre-wrap",
          }}
        >
          <Typography sx={{ color: "#000" }}>
            {description || descriptionFunc}
          </Typography>
        </Stack>
      )}
    </BaseComponent>
  );
};

export default CluppDropdown;
